import { __assign } from "tslib";
import { selectors as streamSelectors } from '../../Stream';
import { getGroupsStreamId, getFolderStreamId, getGroupFolderKey, } from './helpers';
import { GROUPS_PER_FETCH, GROUP_FOLDERS_PER_FETCH } from './saga';
import { reduxKey } from './constants';
export function getHasNoGroups(state) {
    var streamId = getGroupsStreamId();
    return (streamSelectors.isInitialized(state, streamId) &&
        !streamSelectors.hasMore(state, streamId) &&
        !streamSelectors.isFetching(state, streamId) &&
        streamSelectors.getItems(state, streamId).length === 0);
}
export function getHasOnlyOneChunkOfGroupsToLoad(state) {
    var streamId = getGroupsStreamId();
    var isFetching = streamSelectors.isFetching(state, streamId);
    if (isFetching) {
        // don't know yet
        return false;
    }
    return (!streamSelectors.hasMore(state, streamId) &&
        streamSelectors.getItems(state, streamId).length <= GROUPS_PER_FETCH);
}
export function getHasOnlyOneChunkOfGroupFoldersToLoad(state, type, groupId) {
    var streamId = getFolderStreamId(type, groupId);
    var isFetching = streamSelectors.isFetching(state, streamId);
    if (isFetching) {
        // don't know yet
        return false;
    }
    return (!streamSelectors.hasMore(state, streamId) &&
        streamSelectors.getItems(state, streamId).length <= GROUP_FOLDERS_PER_FETCH);
}
export function getGroupsStream(state) {
    var streamId = getGroupsStreamId();
    return {
        streamId: streamId,
        groups: streamSelectors.getItems(state, streamId),
        isFetching: streamSelectors.isFetching(state, streamId),
    };
}
export function getFolderStream(state, deviationId, type, groupId) {
    var streamId = getFolderStreamId(type, groupId);
    var folders = streamSelectors.getItems(state, streamId);
    return {
        streamId: streamId,
        folders: folders.map(function (folder) { return (__assign({ folder: folder }, getGroupFolderState(state, deviationId, {
            groupId: groupId,
            type: type,
            folderId: folder.folderId,
        }))); }),
        isFetching: streamSelectors.isFetching(state, streamId),
        hasMore: streamSelectors.hasMore(state, streamId),
    };
}
export function getGroup(state, groupId) {
    var streamId = getGroupsStreamId();
    var items = streamSelectors.getItems(state, streamId);
    if (!items) {
        return;
    }
    return items.find(function (group) { return group.userId === groupId; });
}
export function getGroupUsername(state, groupId) {
    var group = getGroup(state, groupId);
    return group && group.username;
}
export function getGroupFolderState(state, deviationId, groupFolderId) {
    var folderKey = getGroupFolderKey(deviationId, groupFolderId);
    var folderState = state[reduxKey] && state[reduxKey][folderKey];
    return __assign({ loading: false, added: false, suggested: false }, folderState);
}
//# sourceMappingURL=selectors.js.map